import React from 'react'
import styles from './AddContact.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import InputFlagPhone from 'components/ContentBox/Global/InputPhone/InputFlagPhone/InputFlagPhone'
import useLocalization from 'hooks/useLocalization'
import { observer } from 'mobx-react'

const AddContact = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'customer_card',
    dict: {
      contacts: 'Contacts',
      additional_number: 'Additional number',
    },
  })

  return (
    <div className={styles.groupForm}>
      <FormField>
        <FormLabel isRequired>{translate.contacts}:</FormLabel>
        <InputFlagPhone
          error={check('phone')}
          value={modalValue.phone || modalValue.whatsapp || ''}
          onChange={(val) => changeValues(val, 'phone')}
        />
      </FormField>
      <FormField>
        <FormLabel>{translate.additional_number}:</FormLabel>
        <InputFlagPhone
          value={modalValue.additional_phone || ''}
          onChange={(val) => changeValues(val, 'additional_phone')}
        />
      </FormField>
      <FormField>
        <FormLabel>{'Email'}:</FormLabel>
        <FormInput isError={check('email')}>
          <input
            name='email'
            onChange={(e) => changeValues(e.target.value, 'email')}
            placeholder={'Email'}
            value={modalValue.email || ''}
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default observer(AddContact)
